/**
* @author lmcarrillo <lmcarrillo@sergas.net>
* @copyright Boqueixon 2023
* @version 20.60.60
* @license licenses.txt
*
* @date 2023-03-19 12:47:50
**/

import { Component , OnInit } from "@angular/core";
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from "@angular/router";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { environment } from "./../../../../src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { Globals } from "../../class/globals/globals";
import { TranslateConfiguration } from "../../class/translate-configuration/translate-configuration";
import { interval } from "rxjs";
import { take } from "rxjs/operators";
import { Platform } from "@ionic/angular";
import { HttpClientJsonpModule } from "@angular/common/http";
import { Insomnia } from "@ionic-native/insomnia/ngx";
import { PopoverController } from "@ionic/angular";
import { PopoverComponent } from "../../components/popover/popover.component";



@Component({
	selector: "app-radio",
	templateUrl: "radio.page.html",
	styleUrls: ["radio.page.scss"],
})

export class RadioPage {
	
	pageName:string = `radio` ;
	
	/**
	* RadioPage:constructor()
	**/
	constructor(
		private router: Router,
		public statusBar: StatusBar,
		public translateService: TranslateService,
		public platform: Platform,
		public insomnia: Insomnia,
		public popoverController: PopoverController,
		private storage: Storage,
		private globals: Globals,
		private translateConfiguration: TranslateConfiguration
	){
	
		// statusbar
		this.statusBar.styleBlackOpaque();
		this.statusBar.overlaysWebView(false);
		this.statusBar.backgroundColorByHexString("#0955b3");
	
		// translate
		this.translateConfiguration.setDefaultLanguage();

	
	

		console.log(`RadioPage`,`pageName`,this.pageName);
	}
	
	/**
	* RadioPage:showPopover()
	**/
	async showPopover(ev: any) {
		const popover = await this.popoverController.create({
			component: PopoverComponent,
			event: ev,
			translucent: true
		});
		return await popover.present();
	}
	
	


		
	radioUrl: string = `https://playerservices.streamtheworld.com/api/livestream-redirect/SER_GALICIA.mp3`;
	radioPlayer: any ;
	radioStatus: string = `Detenido`;
	isPlay: boolean = false;
	radioPlaybackPosition: number = 0;
	
	
	
	
	/**
	* RadioPage:ngOnInit()
	**/
	ngOnInit(){
		this.radioPlayer = new Audio(this.radioUrl);
		this.radioPlayer.id = "radio-player-1604603097";
		//console.log("1st",this.radioPlayer);
		this.updateStatus();
	}
	
	ionViewWillLeave(){
		this.radioPlayer.pause();
	}
	/**
	* RadioPage:play()
	**/
	play(){
		this.isPlay = true;
		this.radioStatus = `Reproducido`;
		this.radioPlayer.play();
	
		if (this.platform.is("cordova")){
			this.insomnia.keepAwake().then(
				() => console.log("keepAwake: success"),
				() => console.log("keepAwake: error")
			);
		}
	
	}
	
	/**
	* RadioPage:pause()
	**/
	pause(){
		this.isPlay = false;
		this.radioStatus = `Pausado`;
		this.radioPlayer.pause();
	}
	
	/**
	* RadioPage:stop()
	**/
	stop(){
		this.isPlay = false;
		this.radioStatus = `Detenido`;
		this.radioPlayer.pause();
	
		if (this.platform.is("cordova")){
			this.insomnia.allowSleepAgain().then(
				() => console.log("allowSleep: success"),
				() => console.log("allowSleep: error")
			);
		}
	
	}
	
	/**
	* RadioPage:updateStatus()
	**/
	updateStatus(){
		
		// playback position
		const numbers_playback = interval(1000);
		numbers_playback.pipe().subscribe(num => {
			this.radioPlaybackPosition = this.radioPlayer.currentTime ;
		})
		
		const numbers_state = interval(1000);
		numbers_state.pipe().subscribe(num => {
			// event status update
			let status = this.radioPlayer.readyState;
			switch(status){
				case 0:{
					this.radioStatus = `Pulsa el boton play`;
					break;
				}
				case 1:{
					this.radioStatus = `Se recuperó el recurso multimedia`;
					break;
				}
				case 2:{
					this.radioStatus = `Los datos están disponibles`;
					break;
				}
				case 3:{
					this.radioStatus = `Datos de la posición de reproducción actual`;
					break;
				}
				case 4:{
					this.radioStatus = `Emisora en línea`;
					break;
				}
				default :{
					this.radioStatus = `Nada`;
					break;
				}
			}
		})
		
	}
	
	
	/**
	* RadioPage:filterItems($event)
	* @param any $event
	*
	* @required for searchbar
	**/

	




}
